import { render, staticRenderFns } from "./InventoryTab.vue?vue&type=template&id=2b9568db&scoped=true"
import script from "./InventoryTab.vue?vue&type=script&lang=js"
export * from "./InventoryTab.vue?vue&type=script&lang=js"
import style0 from "./InventoryTab.vue?vue&type=style&index=0&id=2b9568db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9568db",
  null
  
)

export default component.exports